define('app/application',["jquery", "underscore", "knockout", "require", "bootstrap", "wow", "errors", "enums", "api", "navigation", "notifications", "i18n", "../../components/loader", "bindings/knockout.inlinecomponent", "bindings/knockout.svgicon", "bindings/knockout.loadingindicator", "bindings/knockout.page", "scrollblocker"], function ($, _, ko, require, bootstrap, WOW, errors, enums, api, navigation, notifications, i18n, componentloader, koinlinecomponent, kosvnicon, koloadingindicator, kopage, ScrollBlocker) {
  var application = {};
  var viewmodelName = $("body").data("vegzone-viewmodel");
  var widgetsIdx = 0;
  var apiBaseUrl = $("body").data("vegzone-apibaseurl");
  var scrollblocker;

  window.vzapp = application;
  
  application.enums = enums;
  application.t = i18n.t;
  application.routes = i18n.routes;
  application.errors = errors;
  application.widgets = {};
  application.isAuthenticated = ko.observable(window.cordova ? localStorage.getItem("VeggieZoneUser") : $("body").data("vegzone-isauthenticated"));
  application.currentUser = ko.observable(JSON.parse(window.cordova ? localStorage.getItem("VeggieZoneUser") : $("#SerializedCurrentUserInfo").val()));
  application.currentUserState = ko.observable(null);
  application.isActivated = ko.computed(function () {
      var state = application.currentUserState();
      var user = application.currentUser();
      
      return (user && user.IsActivated) || (state && state.IsActivated);
  });
  application.isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) != null;
  application.isAdmin = ko.pureComputed(function () { return application.currentUser() && application.currentUser().IsAdmin });
  application.enableSPA = $("body").data("vegzone-enablespa") || window.navigator.standalone;
  application.isApp = typeof window.cordova === "object" || $("body").data("vegzone-enableapp");
  application.isAppIOS = application.isApp && window.cordova.platformId == "ios";
  application.isAppAndroid = application.isApp && window.cordova.platformId == "android";
  application.isAppBrowser = application.isApp && window.cordova.platformId == "browser";
  application.isAppDevice = application.isAppIOS || application.isAppAndroid;
  application.isWebsite = !application.isApp;
  application.appVersion = $("body").data("vegzone-appversion");
  application.appBuild = $("body").data("vegzone-appbuild");
  
  if(application.enableSPA) $("body").addClass("vz-spa");
  if(window.navigator.standalone) $("body").addClass("vz-standalone");
  
  if(application.isApp && !api.getBaseUrl()) {
      if(window.location.hostname == "localhost") api.setBaseUrl(window.location.origin);
      else api.setBaseUrl(apiBaseUrl);
  }

  application.navigation = new navigation(application);
  application.notifications = new notifications(application);
  
  if(window.cordova)
  {
      application.currentUser.subscribe(function (user) {
          if(user) {
              localStorage.setItem("VeggieZoneUser", JSON.stringify(user));
              application.notifications.sendTokenToApi();
          }
          else {
              localStorage.removeItem("VeggieZoneUser");
          }
      });
      
      if(application.currentUser())
          application.notifications.sendTokenToApi();
      
      application.currentUserState.subscribe(function (state) {
          var notificationsCount = state ? state.NotificationsCount : 0;

          if(window.cordova && window.cordova.platformId == "ios" && window.VegZonePushNotificationsPlugin)
            window.VegZonePushNotificationsPlugin.setBadgeNumber(notificationsCount);
          else if(window.FirebasePlugin)
            window.FirebasePlugin.setBadgeNumber(notificationsCount);
      });
      
      if(window.location.hash.length > 1 && window.location.hash.startsWith("#/")) application.navigation.navigate(window.location.hash.substring(1), false, false, null, true);
      else application.navigation.navigate(i18n.routes.placesRoot, false, false, null, true);
  }

  $(function () {
    new WOW().init();

    $(window).scroll(function() {
        if ($(document).scrollTop() > 50) {
            $('nav').addClass('navbar-shrink');
        } else {
            $('nav').removeClass('navbar-shrink');
        }
    });

    $("body").on("hidden.bs.modal", ".modal", function () {
        if ($('.modal:visible').length) {
            $("body").addClass('modal-open');
        }
    });
    
    // if(window.cordova)
    // {
    //     require(["pulltorefresh"], function (PullToRefresh) {
    //         var ptr = PullToRefresh.init({
    //             mainElement: 'body',
    //             onRefresh() {
    //                 console.log("refresh");
    //             }
    //         });
    //     });
    // }
  });
  
  var handleBookmarkletActions = function () {
      if(window.location.hash.indexOf("pin=") >= 0)
      {
          var url = decodeURIComponent(window.location.hash.substring(5));

          application.loadWidget('modal:createpost', { kind: 'url', showDetailAfterCreate: true, predefinedUrl: url });
      }
  };

    var runKnockout = function (viewmodel) {
        $(function () {
            ko.bindingProvider.instance.parseBindingsString = function(bindingsString, bindingContext, node, options) {
                try {
                    return new window.expbindings[bindingsString](bindingContext, node);
                }
                catch (e) {
                    console.error("Error in binding " + bindingsString, e);
                    
                    return null;
                }
            };
            
            componentloader(application);
            
            if (viewmodel && typeof viewmodel.run === "function")
                viewmodel.run(application);
    
            try {
                ko.applyBindings(application, window.document.body);
            }
            catch(e)
            {
                console.error("Error in application viewmodel binding", e);
            }
    
            if (viewmodel && typeof viewmodel.loaded === "function")
                window.setTimeout(function() {
                    viewmodel.loaded(application);
                }, 0);
    
            window.setTimeout(function() {
                $(".page-preloader-cover").hide();
            }, 0);
    
            $("body").on("click", "a.require-login", function (event) {
                if(!application.isAuthenticated()) {
                    application.ensureLogin()
                        .done(function () {
                            window.setTimeout(function() {
                                application.navigation.navigate($(event.target).attr("href"));
                            }, 0);
                        });
                    event.preventDefault();
                }
            });

            $(document)
                .one('focus', 'textarea.autoexpand', function(){
                    this.baseScrollHeight = this.scrollHeight;
                    this.baseRows = this.rows;
                })
                .on('input', 'textarea.autoexpand', function(){
                    this.rows = 1;
                    var rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 24);
                    console.log(rows, this.baseScrollHeight, this.scrollHeight);
                    this.rows = this.baseRows + rows;
                });
            
            $("body").on("click", ".section-toggle", function (event) {
                event.preventDefault();
                
                $link = $(this);
                
                if($link.data("vz-section-toggle-target"))
                {
                    $($link.data("vz-section-toggle-target")).toggleClass("active");
                } else if($link.data("vz-section-toggle-closest")) {
                    $link.closest($link.data("vz-section-toggle-closest")).toggleClass("active");
                } else {
                    $link.parents(".modal-section").toggleClass("active");
                }

                $link.toggleClass("toggled");
            });

            $("body").on("click", ".widget-link", function (event) {
                event.preventDefault();
                
                application.loadWidget($(this).data("vz-widget-name"), $(this).data("vz-widget-data"));
            });

            $(document).on("click", ".popover-link", function (event) {
                event.preventDefault();

                $(this).popover({
                    trigger: "focus",
                    placement: "bottom"
                });
                
                $(this).focus();
            });

            $(function(){
                var navMain = $(".navbar-collapse");
                navMain.on("click", "a:not([data-toggle])", null, function () {
                    navMain.collapse('hide');
                });
            });
            
            $(".fabbutton,.fabmenu").on("click", function (event) {
                $(".triggerButton").prop("checked", false);
            });

            $(document).on("click", ".collapse-block-header a", function (event) {
                event.preventDefault();
                event.stopPropagation();

                $(this).parents(".collapse-block-container").toggleClass("show");

                return false;
            });

            $(".navbar-collapse").on("shown.bs.collapse", function (event) {
                scrollblocker = new ScrollBlocker($(".navbar-collapse")[0]);
                console.log("collapse", event);
            });

            $(".navbar-collapse").on("hidden.bs.collapse", function (event) {
                if(scrollblocker) scrollblocker.unload();
                scrollblocker = null;
            });            
            
            api.setSoftErrorCallback(application.softError);
            handleBookmarkletActions();
        });
    };

  if (viewmodelName && viewmodelName.length) {
    require(["app/" + viewmodelName], function (viewmodel) {
      if(typeof viewmodel === "function")
          viewmodel = new viewmodel();
      
      application[viewmodelName] = viewmodel;
      runKnockout(viewmodel);
    });
  } else {
    runKnockout();
  }

    application.loadWidget = function (widgetname, parameters) {
        var deferred = new $.Deferred();
        
        $(".page-loader").show();
        
        var scheme = null;
        
        if(widgetname.indexOf(":") > 0)
        {
            scheme = widgetname.split(':')[0];
            widgetname = widgetname.split(':')[1];
        }
        
        var directory = widgetname;
        var filename = widgetname;

        if(widgetname.indexOf("/") > 0)
        {
            directory = widgetname.split('/')[0];
            filename = widgetname.split('/')[1];
        }

        // Start the photo lookup on click, while RequireJS resolves the widget.
        // Do not mutate the caller's options or start a second request in init.
        if (widgetname === "photogallery" && parameters && parameters.venueId && !parameters.photoRequest) {
            parameters = $.extend({}, parameters, {
                photoRequest: api.get("/api/venues/" + parameters.venueId + "/photos?kind=" + encodeURIComponent(parameters.kind || "images"))
            });
        }

        // Use the same canonical IDs as the optimizer. RequireJS preserves
        // app/../../ in legacy relative widget IDs, even when URLs coincide.
        var modules = widgetname === "photogallery"
            ? ["photogallery", "text!photogallery-template"]
            : ["../../widgets/" + directory + "/" + filename, "text!../../widgets/" + directory + "/" + filename + ".html"];
        require(modules, function (widget, html) {
            html = i18n.localizeTemplate(html);
            $(".page-loader").hide();
            
            var instance = null;
            var instanceName = widgetname.replace("/", "_");
            if (typeof widget === "object") {
                instance = widget;
            } else if (typeof widget === "function") {
                instance = new widget();
                instanceName += "_" + widgetsIdx++;
            } else {
                throw "Invalid widget";
            }

            var isNewInstance = false;
            if (application.widgets[instanceName] != instance) {
                application.widgets[instanceName] = instance;
                isNewInstance = true;
            }

            console.log("component", isNewInstance);

            instance.init(parameters || {}, application, deferred);

            if (isNewInstance && html) {
                var widgetHtml = html;
                
                if(scheme == "modal") {
                    var modalFooterRegExp = new RegExp("<!-- modal-footer -->([\\s\\S]*)<!-- /modal-footer -->");
                    console.log(modalFooterRegExp.exec(html));
                    window.rr = modalFooterRegExp;
                    window.hh = html;
                    var modalFooter = "";
                    var modalFooterMatch = modalFooterRegExp.exec(html)
                    
                    if(modalFooterMatch) {
                        html = html.replace(modalFooterRegExp, "");
                        modalFooter = modalFooterMatch[1];
                    }
                    
                    widgetHtml = '<div class="modal' + (instance.modalClasses ? ' ' + instance.modalClasses : '') + '" data-bind="modal: showModal" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header" data-bind="visible: $data.modalTitle">\n' +
                        '                <div class="modal-titlebar">' +
                        '<h5 class="modal-title" data-bind="text: $data.modalTitle"></h5>' +
                        '<div class="modal-subtitle" data-bind="visible: $data.modalSubtitle">' +
                        '<div class="modal-subtitle-text" data-bind="text: $data.modalSubtitle">' +
                        '</div>' +
                        '<div class="modal-subtitle-buttons" data-bind="visible: $data.modalSubTitleButtons, foreach: $data.modalSubTitleButtons"><button data-bind="css: $data.buttonCss, click: $data.buttonClick"><svg class="svg-icon" data-bind="svgicon: buttonIcon"></svg></button></div>' +
                        '</div>' +
                        '<div class="modal-title-buttons" data-bind="visible: $data.modalTitleButtons, foreach: $data.modalTitleButtons"><button data-bind="css: $data.buttonCss, click: $data.buttonClick"><svg class="svg-icon" data-bind="svgicon: buttonIcon"></svg></button></div>' +
                        '</div>\n' +
                        '                <button type="button" class="close" data-dismiss="modal" aria-label="' + i18n.t("Frontend.Close") + '">\n' +
                        '                    <span aria-hidden="true"><svg class="svg-icon" data-bind="svgicon: \'close\'"></svg></span>\n' +
                        '                </button>\n' +
                        '            </div>\n<div class="modal-body">' + html + '</div>' +
                        modalFooter +
                        '<div class="modal-footer" data-bind="visible: $data.modalButtons, foreach: $data.modalButtons">' +
                        '<div><!-- ko if: typeof $data.buttonClick != "undefined" -->' +
                        '<button data-bind="css: $data.buttonCss, html: $data.buttonText, click: $data.buttonClick, visible: typeof ko.unwrap($data.buttonVisible) !== \'undefined\' ? ko.unwrap($data.buttonVisible) : true"></button>' +
                        '<!-- /ko -->' +
                        '<!-- ko if: $data.buttonType == "cancel" -->' +
                        '<button data-bind="css: $data.buttonCss, html: $data.buttonText" data-dismiss="modal"></button>' +
                        '<!-- /ko --></div>' +
                        '</div>' +
                        '</div></div></div>';
                }
                
                var $widget = $('<div id="widget_instance_' + instanceName + '" class="dynamic-widget" data-vegzone-widgetinstance="' + instanceName + '" data-bind="let: {$widget: $root.widgets[$element.dataset.vegzoneWidgetinstance]}"><div data-bind="with: $widget">' + widgetHtml + '</div></div>');

                $widget.appendTo(document.body);

                if (typeof(instance.inserted) === "function")
                    instance.inserted($widget[0]);

                ko.applyBindings(application, $widget[0]);
                if (typeof(instance.bounded) === "function")
                    instance.bounded();
            }

            window.whtml = instance.$html;

            instance.unload = function () {
                console.log("instance.unload");
                ko.removeNode($("#widget_instance_" + instanceName)[0]);
                delete application.widgets[instanceName];
            };
        });
        
        return deferred;
    };
  
    application.invokeAction = function(action, parameters) {
        var deferred = new $.Deferred();
        var actionScript = action;
        var actionName = action;

        if(actionName.indexOf(":") > 0)
        {
            actionScript = actionName.split(':')[0];
            actionName = actionName.split(':')[1];
        }

        var directory = actionScript;
        var filename = actionScript;

        if(actionScript.indexOf("/") > 0)
        {
            directory = actionScript.split('/')[0];
            filename = actionScript.split('/')[1];
        }

        require(["../../actions/" + directory + "/" + filename], function (actionHandler) {
            var instance = null;
            
            if (typeof actionHandler === "object") {
                instance = actionHandler;
            } else if (typeof actionHandler === "function") {
                instance = new actionHandler();
            } else {
                throw "Invalid action handler";
            }
            
            instance.run(actionName, parameters || {}, application, deferred);
        });
        
        return deferred;
    };
    
  application.ensureLogin = function (parameters) {
      var deferred = new $.Deferred();
      
      if (application.currentUser()) {
          deferred.resolve(application.currentUser());
          return deferred;
      }
      
      var initiateLogin = function () {
          application.loadWidget("modal:login", {
              successCallback: function (loggedUser) {
                  application.currentUser(loggedUser);
                  application.isAuthenticated(loggedUser != null);
                  deferred.resolve(application.currentUser());
              }, failedCallback: function () {
                  deferred.reject(true);
              }
          });
      }
      
      if(parameters && parameters.reason)
      {
            application.loadWidget("popover", {
                title: i18n.t("Frontend.PrihlaseniKVeggiezoneUctu"),
                content: typeof parameters.reason === "string" ? parameters.reason : i18n.t("Frontend.ProTutoAkciJeVyzadovanoPrihlaseni"),
                buttons: [{ id: "login", text: i18n.t("Frontend.PrihlasitSe")}]
            }).done(function (result) {
                if(result && result.id === "login")
                    initiateLogin();
            });
      } else {
          initiateLogin();
      }
          
      return deferred.promise();
  };
  
  application.loadUserState = function() {
      var deferred = new $.Deferred();

      if (!application.currentUser()) {
          deferred.resolve(null);
          return deferred;
      }

      api.get("/api/account/state")
          .done(function (result) {
              if(!_.isEqual(result, application.currentUserState())) {
                  console.log("stage changed");
                  application.currentUserState(result);
              } else {
                  console.log("stage unchanged");
              }
              deferred.resolve(application.currentUserState());
          })
          .fail(function (result) {
              deferred.reject();
          });

      return deferred.promise();
  };
  
  application.loadUserInfo = function () {
      var deferred = new $.Deferred();

      api.get("/api/account/me")
          .done(function (result) {
              if(result) {
                  if (!_.isEqual(result, application.currentUser())) {
                      application.currentUser(result);
                  }
              } else {
                  application.logout();
              }
              deferred.resolve(result);
          })
          .fail(function (result) {
              deferred.reject();
          });

      return deferred.promise();      
  };
  
  application.logout = function() {
      return new Promise(function (resolve, reject) {
          application.isAuthenticated(false);
          application.currentUser(null);
          api.removeToken().then(resolve).catch(reject);
      });
  };
  
  application.isMe = function (user) {
      var currentUser = application.currentUser();
      
      if(!currentUser)
          return false;
      
      var u = ko.unwrap(user);
      
      if(typeof u.Id !== "undefined")
          return  ko.unwrap(u.Id) == currentUser.Id;
      else if(typeof u === "number")
          return u == currentUser.Id;
      
      return false;      
  }

  application.currentUserStateTimer = false;
  
  if (application.currentUser() != null)
  {
      application.currentUserStateTimer = true;
      application.loadUserState();
      window.setInterval(application.loadUserState, 30000);
  } else {
      application.currentUser.subscribe(function () {
          application.loadUserState();

          if (!application.currentUserStateTimer) {
              application.currentUserStateTimer = true;
              window.setInterval(application.loadUserState, 30000);
          }
      });
  }
  
  if(window.cordova)
      application.loadUserInfo();

  window.onbeforeunload = function() {
      $(".page-preloader-cover").show();
  };
  
  application.softError = function (error, handlerName, data) {
      switch(handlerName)
      {
          case "GlobalErrorMessage":
              if(data) application.loadWidget("dialog", {title: data.Title, content: data.Message, buttons: [{ text: data.ButtonText, url: data.ButtonUrl }] });
              else application.loadWidget("dialog", errors[error]);
              break;
      }
  };
  
  application.events = {};
  application.events.list = {};
  application.events.addEventListener = function (eventName, callback) {
      var callbacks = application.events.list[eventName];
      if (!callbacks)
      {
          callbacks = [];
          application.events.list[eventName] = callbacks;
      }
      
      if (callbacks.indexOf(callback) == -1) 
        callbacks.push(callback);
      
      return callback;
  };
  
  application.events.removeEventListener = function(eventName, callback) {
      var callbacks = application.events.list[eventName];
      if (!callbacks)
          return;

      if (callbacks.indexOf(callback) != -1)
          callbacks.splice(callbacks.indexOf(callback), 1);
  };
  
  application.events.fire = function (eventName, data, resultCallback) {
      window.setTimeout(function () {
        var callbacks = application.events.list[eventName];
        if (callbacks)
        {
            $.each(callbacks, function () {
                this(data, eventName, application, resultCallback);
            });
        }
      }, 0);
  };
  
  application.contextMenu = {};
  application.contextMenu.items = ko.observableArray();
  application.contextMenu.add = function(item) {
      application.contextMenu.items.push(item);
  };
  application.contextMenu.update = function(items) {
      application.contextMenu.items(items);
  };
  application.contextMenu.clear = function() {
      application.contextMenu.items([]);
  };
  
  application.fullUrl = function(url)
  {
      if(!url)
          return url;
      
      if(window.cordova)
      {
          var unwrapped = ko.unwrap(url);
          if(!unwrapped)
              return url;

          if(unwrapped.indexOf("/") == 0)
              return apiBaseUrl + unwrapped;
      }
  
      return url;
  };  
  
  application.translateUrl = function(url) {
      if(!url)
          return url;
      
      if(window.cordova)
      {
          var unwrapped = ko.unwrap(url);
          if(!unwrapped)
              return url;
          
          if(unwrapped.toLowerCase().indexOf("/content") == 0)
              return unwrapped.substr(1);
          
          if(unwrapped.indexOf("/") == 0)
              return apiBaseUrl + unwrapped;
      }
      
      return url;
  };
  
  application.speedyImage = function (url, settings) {
      var resamplerUrl = "https://veggiezone.cz/shared/imgproxy.ashx";
      var params = {"f": url};
      
      if(typeof settings === "object") $.extend(params, settings)
      else if(typeof settings === "string")
      {
          switch (settings)
          {
              case "main100":
                  $.extend(params, {"w": 100, "h": 100, "crop": 1, "q": 100});
                  break;
                  
              case "big640":
                  $.extend(params, {"w": 640, "h": 430, "crop": 1, "q": 100});
                  break;

              case "big960":
                  $.extend(params, {"w": 960, "h": 390, "crop": 1, "q": 100});
                  break;                  
          }
      }
      
      return resamplerUrl + "?" + $.param(params);    
  };
  
  application.toast = function (settings) {
      var text = typeof settings === "string" ? settings : settings.text;
      var title = settings.title || "";
      var subtitle = settings.subtitle || "";
      var autohide = settings.autohide || false;
      var delay = settings.delay || 5000;
      
      var $toast = $("<div class=\"toast fade\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\n" +
          "  <div class=\"toast-header\">\n" +
          "    \n" +
          "    <strong class=\"mr-auto\">" + title + "</strong>\n" +
          "    <small class=\"text-muted\">" + subtitle + "</small>\n" +
          "    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"" + i18n.t("Frontend.Close") + "\">\n" +
          "      <span aria-hidden=\"true\">×</span>\n" +
          "    </button>\n" +
          "  </div>\n" +
          "  <div class=\"toast-body\">\n" +
              text +
          "  </div>\n" +
          "</div>");
      
      $toast.appendTo("body");
      $toast.toast({
          autohide: autohide,
          delay: delay
      });
      $toast.toast("show");
      $toast.on('hidden.bs.toast', function () {
          $toast.remove();
      });
  };
  
  if(application.isWebsite) {
      if (navigator.serviceWorker) {
          navigator.serviceWorker.register("/Content/js/service-worker.js", {scope: "/"}).then(function (registration) {
              console.log("ServiceWorker registration successful with scope:", registration.scope);
          }).catch(function (error) {
              console.log(`ServiceWorker registration failed:`, error);
          });
      }
  }

  application.formatters = {
      money: new Intl.NumberFormat(i18n.locale, {
          style: 'currency',
          currency: i18n.country === 'SK' ? 'EUR' : 'CZK'
      })
  }
  
  application.events.addEventListener("internalcommand", function (data, eventName, lapp, resultCallback) {
        switch(data.command)
        {
            case "apiurl":
                api.setKnownBaseUrl(data.parameters);
                if(typeof resultCallback === "function")
                    resultCallback({
                        data: data,
                        eventName: eventName,
                        application: lapp,
                        result: i18n.t("Frontend.ApiUrlSetTo", [data.parameters])
                    });
                break;
                
            case "reload":
                window.location.reload();
                break;
        }
  });
  
  return application;
});

